import React from 'react';
import cn from 'classnames';
import selectFundsRibbon from '../../images/select-funds-ribbon.svg';
import styles from './style.css';
import SFMethodologyModal from './SFMethodologyModal';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import { modalOpenHandler } from '../Modal/utils';

const SelectFundsMethodology = ({ showSelectFundInfo = false }) => {
  return (
    <div
      className={cn('methodology-wrapper', {
        'methodology-wrapper-display': !showSelectFundInfo
      })}>
      {showSelectFundInfo && (
        <>
          <img src={selectFundsRibbon} alt="Select Funds Certified" />
          <p className="select-funds-info">T. Rowe Price® Select Funds</p>
          <br />
          <p className="select-funds-info">
            Curated mutual funds based on a combination of factors.
          </p>
          <MFBeaconButton
            id="selectFundsMethodologyReviewBtn"
            data-name="selectFundsMethodologyReviewBtn"
            onClick={() => modalOpenHandler('sfMethodologyModal')}
            variant="tertiary"
            label="Review our Criteria"
          />
        </>
      )}
      <SFMethodologyModal />
      <style jsx>{styles}</style>
    </div>
  );
};

export default SelectFundsMethodology;
